import { IMAGE_URL, TOI_SITE_NAME, TOI_SEO_DOMAIN } from '../../constants';

const removeSpecialChar = txt => {
  if (txt && typeof txt === 'string') {
    txt.replace(/"/, '');
  } else {
    txt = '';
  }
  return txt;
};

const getAuthorDetails = data => {
  if (
    data &&
    data.audetails &&
    data.audetails.primary &&
    data.audetails.primary.name
  ) {
    return data.audetails.primary.name;
  }
  return '';
};

const getPhotstoryBody = data => {
  let body = '';
  if (data && Array.isArray(data.items) && data.items.length > 0) {
    data.items.forEach(item => {
      if (item && item.cap) {
        body += item.cap;
      }
    });
  }
  const htmltagsRegex = /(<([^>]+)>)/gi;

  body = body.replace(htmltagsRegex, '');

  return body;
};

const newsArticleSchema = {
  '@context': 'https://schema.org',
  '@type': 'NewsArticle',
  mainEntityOfPage: '',
  inLanguage: 'en',
  headline: '',
  image: {
    '@type': 'ImageObject',
    url: '',
    height: 720,
    width: 1280,
  },
  datePublished: '',
  dateModified: '',
  author: {
    '@type': 'Organization',
    name: TOI_SITE_NAME,
  },
  publisher: {
    '@type': 'Organization',
    name: TOI_SITE_NAME,
    url: TOI_SEO_DOMAIN,
    logo: {
      '@type': 'ImageObject',
      url: 'https://static.toiimg.com/photo/msid-58127550/58127550.jpg',
      width: 600,
      height: 60,
    },
  },
  description: '',
  articleBody: '',

  //   keywords: '',
  //   url: '',
  //   alternativeHeadline: '',
};
const htmltagsRegex = /(<([^>]+)>)/gi;
const generatePhotostorySchema = (photostoryData, seoData) => {
  const mainEntitySchema = {
    '@type': 'WebPage',
    '@id': seoData?.canonical || photostoryData?.wu,
  };
  const author = getAuthorDetails(photostoryData);
  const agency =
    photostoryData && photostoryData.agency && photostoryData.agency.name;

  newsArticleSchema.mainEntityOfPage = mainEntitySchema;
  newsArticleSchema.headline = removeSpecialChar(
    photostoryData?.secname,
  ).replace(htmltagsRegex, '');
  newsArticleSchema.image.url = seoData.ogimage.includes(IMAGE_URL)
    ? `${seoData.ogimage}`
    : `${IMAGE_URL}${seoData.ogimage}`;
  newsArticleSchema.dateModified = seoData.dateModified;
  newsArticleSchema.datePublished = seoData.datePublished;
  if (author) {
    newsArticleSchema.author['@type'] = 'Person';
    newsArticleSchema.author.name = author;
  } else if (agency) {
    newsArticleSchema.author['@type'] = 'Thing';
    newsArticleSchema.author.name = agency;
  }
  newsArticleSchema.description = seoData.description;
  newsArticleSchema.articleBody = getPhotstoryBody(photostoryData);

  return JSON.stringify(newsArticleSchema);
};

export default generatePhotostorySchema;
